import React from "react";

import Svg from "../../svg/Svg";
import { Image as DefaultImage } from "../../svg/svgImageList";

interface PlaceholderImageProps {
  image?: React.FunctionComponent;
}

export default function PlaceholderImage({ image }: PlaceholderImageProps) {
  return <Svg className="placeholder" svg={image || DefaultImage} width="100%" height="100%" />;
}
